// extracted by mini-css-extract-plugin
export default {"copy":"CopyIdButton_copy__GZ8wG","hoverOnly":"CopyIdButton_hoverOnly__3Ibas","done":"CopyIdButton_done__UEIYH"};